import { forwardRef } from "react";

import { Autocomplete } from "@mui/material";
import PropTypes from "prop-types";

import { useAuth } from "@/features/authentication";
import { OutletRoleEnum } from "@/features/outlets/outlet-role";
import { CustomInputField } from "@/features/ui";

export const UserOutletsSelect = forwardRef(
  (
    {
      value,
      onChange,
      disabled,
      TextFieldProps,
      allowedRoles = [OutletRoleEnum.HUB, OutletRoleEnum.RETAIL],
      disableClearable = true,
      ...props
    },
    ref
  ) => {
    const {
      user: { outlets },
    } = useAuth();

    const filteredOutlets = outlets.filter((outlet) =>
      allowedRoles.includes(outlet.role)
    );

    return (
      <Autocomplete
        ref={ref}
        value={value ?? null}
        onChange={(_, newValue) => onChange(newValue)}
        disabled={disabled}
        options={filteredOutlets}
        disableClearable={disableClearable}
        getOptionLabel={(option) => option?.name ?? ""}
        isOptionEqualToValue={(option, selectedOption) =>
          option.id === selectedOption.id
        }
        renderInput={(params) => (
          <CustomInputField
            {...TextFieldProps}
            {...params}
            InputProps={{
              placeholder:
                TextFieldProps?.InputProps?.placeholder || "Pilih Outlet",
              ...params.slotProps.input,
            }}
          />
        )}
        {...props}
      />
    );
  }
);

UserOutletsSelect.displayName = "UserOutletsSelect";

UserOutletsSelect.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  TextFieldProps: PropTypes.object,
  allowedRoles: PropTypes.arrayOf(PropTypes.string),
  disableClearable: PropTypes.bool,
};
